export const SUPPLIER_LIST_QUERY_KEYS = {
	paged: (params: Record<string, unknown>) =>
		["supplier-lists-paged", params] as const,
} as const;
